module.exports = __webpack_public_path__ + "static/media/back-orange-arrow.18a7f98a.svg";